import {createContext } from "react";

const userDataContext=createContext();

export default userDataContext;